import ApiUrls from '@api/apiUrls';
import { fetchApi } from '@api/fetchApi';
import { IApiLoyaltyProgramParticipantUserInfo } from './loyaltyProgramParticipantUser.apiService.interface';

export const apiLoyaltyProgramParticipantUserService = {
  join: async (loyaltyProgramId: number) => {
    return await fetchApi.post(ApiUrls.loyaltyProgramParticipantUser.join, null, {
      params: { loyaltyProgramId },
    });
  },
  stopParticipating: async (loyaltyProgramId: number) => {
    return await fetchApi.post(ApiUrls.loyaltyProgramParticipantUser.stopParticipating, null, {
      params: { loyaltyProgramId },
    });
  },
  getInfo: async (skip: number, take: number) => {
    return await fetchApi.get<IApiLoyaltyProgramParticipantUserInfo[]>(ApiUrls.loyaltyProgramParticipantUser.getInfo, {
      params: { skip, take },
    });
  },
};
